import { useMotionValue } from "framer-motion"
import { createContext, useContext } from "react"

export const Context = createContext()

export const StateProvider = ({ children }) => {
  const currentIndex = useMotionValue(0)
  const targetSlide = useMotionValue(0)
  const globalProg = useMotionValue(0)
  const inputMap = useMotionValue("")

  return <Context.Provider value={{ currentIndex, targetSlide, globalProg, inputMap }}>{children}</Context.Provider>
}

export const useValue = () => useContext(Context)
